var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 14.125L4.08418 13.1454L3.10459 12.1658L2.125 14.125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2066 6.53316C10.4771 6.53316 10.6964 6.31387 10.6964 6.04337C10.6964 5.77286 10.4771 5.55357 10.2066 5.55357C9.93613 5.55357 9.71684 5.77286 9.71684 6.04337C9.71684 6.31387 9.93613 6.53316 10.2066 6.53316Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32908 9.96173L2.3699 9.47194C2.3699 9.47194 2.3699 8.00255 2.85969 6.53316C3.34949 5.06378 6.77806 5.06378 6.77806 5.06378M4.32908 9.96173L6.28827 11.9209M4.32908 9.96173C4.32908 9.96173 6.28827 5.06378 8.73724 3.59439C11.1862 2.125 14.125 2.125 14.125 2.125C14.125 2.125 14.125 5.06378 12.6556 7.51276C11.1862 9.96173 6.28827 11.9209 6.28827 11.9209M6.28827 11.9209L6.77806 13.8801C6.77806 13.8801 8.24745 13.8801 9.71684 13.3903C11.1862 12.9005 11.1862 9.47194 11.1862 9.47194M2.125 14.125L4.08418 13.1454L3.10459 12.1658L2.125 14.125ZM10.6964 6.04337C10.6964 6.31387 10.4771 6.53316 10.2066 6.53316C9.93613 6.53316 9.71684 6.31387 9.71684 6.04337C9.71684 5.77286 9.93613 5.55357 10.2066 5.55357C10.4771 5.55357 10.6964 5.77286 10.6964 6.04337Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.7554f1c52ca7cfcfa294410028164472.svg";
export { ForwardRef as ReactComponent };